document.addEventListener("DOMContentLoaded", function () {
  'use strict';

  // ============================================
  // VARIANT MAP — same source of truth as your HTML
  // ============================================
  const VARIANT_MAP = {
    "1": {
      one_time: { product: 9720447893801, variant: 50449094803753 },
      subscribe: {
        "30": { variant: 50449269326121, plan: 694276030761 },
        "60": { variant: 50449385652521, plan: 694376825129 }
      }
    },
    "3": {
      one_time: { product: 9720323178793, variant: 50448443834665 },
      subscribe: {
        "30": { variant: 50449264378153, plan: 694275932457 },
        "60": { variant: 50449266966825, plan: 694376857897 }
      }
    },
    "6": {
      one_time: { product: 9720323834153, variant: 50448449339689 },
      subscribe: {
        "30": { variant: 50449270833449, plan: 694376890665 },
        "60": { variant: 50449270374697, plan: 694376923433 },
        "90": { variant: 50449271259433, plan: 694376956201 }
      }
    }
  };

  // ============================================
  // GIFT MAP — parent variant → array of free gift variant IDs
  // ============================================
  const FREE_GIFT_MAP = {
    "50449094803753": ["50482674565417"],
    "50449269326121": ["50482669781289", "50482674565417", "50482675515689"],
    "50449385652521": ["50482669781289", "50482674565417", "50482675515689"],
    "50448443834665": ["50463780831529"],
    "50449264378153": ["50463768379689", "50463780831529", "50463787122985", "50459235909929"],
    "50449266966825": ["50463768379689", "50463780831529", "50463787122985", "50459235909929"],
    "50448449339689": ["50482693767465"],
    "50449270833449": ["50482693275945", "50482693767465", "50482694619433", "50459239219497"],
    "50449270374697": ["50482693275945", "50482693767465", "50482694619433", "50459239219497"],
    "50449271259433": ["50482693275945", "50482693767465", "50482694619433", "50459239219497"],
  };

  // ============================================
  // Resolve current selection from the DOM at click time
  // (more reliable than reading button data attrs that PageFly may not update)
  // ============================================
  function resolveSelection() {
    // Which package box (1, 3, or 6)?
    const activeBox = document.querySelector('.package__box.active');
    if (!activeBox) return null;
    const pkgId = activeBox.id.split('_')[1]; // "1", "3", "6"

    // Subscribe or One-Time?
    const isOneTime = document.getElementById('pack-1_otp')?.checked === true;
    const isSubscribe = document.getElementById('pack-1_subscribe')?.checked === true;

    // For subscribe, what frequency?
    const freq = document.getElementById('subscription-frequency')?.value;

    const pkgMap = VARIANT_MAP[pkgId];
    if (!pkgMap) return null;

    if (isOneTime) {
      const ot = pkgMap.one_time;
      return ot ? { variantId: String(ot.variant), sellingPlanId: '', mode: 'one_time', pkgId } : null;
    }

    if (isSubscribe) {
      const sub = pkgMap.subscribe[freq];
      return sub ? { variantId: String(sub.variant), sellingPlanId: String(sub.plan), mode: 'subscribe', pkgId, freq } : null;
    }

    return null;
  }

  // ============================================
  // Take ownership of the button (strip PageFly handlers)
  // ============================================
  function replaceButton() {
    const original = document.getElementById('atc-button');
    if (!original) return null;
    const clone = original.cloneNode(true);
    clone.removeAttribute('data-pf-type');
    original.parentNode.replaceChild(clone, original);
    return clone;
  }

  // ============================================
  // ATC handler
  // ============================================
  async function handleATC(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const btn = e.currentTarget;

    // Resolve fresh from DOM every click — no stale data
    const selection = resolveSelection();

    if (!selection || !selection.variantId) {
      alert('Could not determine selected product. Please refresh and try again.');
      console.error('[CUSTOM ATC] resolveSelection returned null');
      return;
    }

    console.log('[CUSTOM ATC] Resolved selection:', selection);

    const { variantId, sellingPlanId } = selection;
    const isSubscription = sellingPlanId !== '';

    const loader = document.getElementById('cart-loader');
    if (loader) loader.style.display = 'flex';

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const items = [];

      // Main product
      const mainItem = { id: Number(variantId), quantity: 1 };
      if (isSubscription) mainItem.selling_plan = Number(sellingPlanId);
      items.push(mainItem);

      // Free gifts — no selling plan, tagged with parent for sync/remove later
      const giftIds = FREE_GIFT_MAP[variantId] || [];
      console.log('[CUSTOM ATC] Adding', giftIds.length, 'free gifts for variant', variantId);

      giftIds.forEach(giftId => {
        items.push({
          id: Number(giftId),
          quantity: 1,
          properties: {
            "_parent_variant_id": String(variantId),
            "_free_gift": "yes"
          }
        });
      });

      console.log('[CUSTOM ATC] Payload:', JSON.stringify(items, null, 2));

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });

      const data = await res.json();
      console.log('[CUSTOM ATC] Response status:', res.status);

      if (!res.ok) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      console.log('[CUSTOM ATC] Cart now has', cart.items.length, 'lines:', cart.items.map(i => i.title));

      window.location.href = '/cart';
    } catch (err) {
      console.error('[CUSTOM ATC] Error:', err);
      if (loader) loader.style.display = 'none';
      btn.disabled = false;
      btn.textContent = originalText;
      alert('Error adding to cart: ' + err.message);
    }
  }

  // ============================================
  // Init + re-take ownership if PageFly re-renders
  // ============================================
  function init() {
    const btn = replaceButton();
    if (btn) {
      btn.addEventListener('click', handleATC);
      console.log('[CUSTOM ATC] Button cloned & PageFly listeners stripped');
    }
  }

  init();

  const observer = new MutationObserver(() => {
    const current = document.getElementById('atc-button');
    if (current && current.hasAttribute('data-pf-type')) {
      console.log('[CUSTOM ATC] PageFly re-rendered button, re-taking control');
      init();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
